import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface permission {}

interface LoginState {
  user: String;
  heading: String;
  error: string;
  success: boolean;
  isUserLogout: boolean;
  permission: permission;
  isLoginAction: boolean;
  accessDenied: boolean;
}

const initialState: LoginState = {
  user: "",
  heading: "",
  error: "",
  success: false,
  isUserLogout: false,
  permission: [],
  isLoginAction: false,
  accessDenied: false,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    // Clear state before login attempt
    loginRequest(state: LoginState) {
      state.success = false;
      state.error = "";
      state.isLoginAction = false;
      state.accessDenied = false;
    },
    loginSuccess(state: LoginState, action: PayloadAction<string | any>) {
      state.user = action.payload;
      state.success = true;
      state.error = "";
      state.isLoginAction = true;
    },
    headingData(state: LoginState, action: PayloadAction<string | any>) {
      state.heading = action.payload;
      // Don't set isLoginAction here
    },
    loginError(state: LoginState, action: PayloadAction<string | any>) {
      state.error = action.payload;
      state.success = false;
      state.isLoginAction = false;
    },
    logoutSuccess(state: LoginState, action: PayloadAction<boolean>) {
      // RESET TO INITIAL STATE on logout
      return {
        ...initialState,
        isUserLogout: action.payload,
      };
    },
    permissionData(state: LoginState, action: PayloadAction<permission>) {
      state.permission = action.payload;
      // Don't set isLoginAction here
    },
    // Action to clear notifications after showing them
    clearLoginNotifications(state: LoginState) {
      state.success = false;
      state.error = "";
      state.isLoginAction = false;
    },
    setAccessDenied(state: LoginState, action: PayloadAction<boolean>) {
      state.accessDenied = action.payload;
    },
  },
});

export const {
  loginRequest,
  loginSuccess,
  loginError,
  logoutSuccess,
  headingData,
  permissionData,
  clearLoginNotifications,
  setAccessDenied,
} = loginSlice.actions;

export default loginSlice.reducer;